import { useState, useEffect } from "react";
import {useDispatch, useSelector} from 'react-redux';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { CustomFormikMultiselectMod } from "src/shared/components/CustomFormikMultiselectMod";
import { IReactSelectOption } from "src/shared/models/ReactSelect.models";
import { notEmptyArray } from "src/shared/services/SharedService";
import { RootState } from "src/store/reducers";
import { getAllStores } from "src/services/Stores/StoreService";
import { setFilteredStoreList } from 'src/store/Stores/slices/filteredStoresSlice';
import { IFilteredStore } from "src/models/Stores/Store.models";
import { getStoresXUser, setStoresXUser } from "src/services/Stores/FilteredStoreService";
import store_filter from "../../../../assets/icons/store_filter.png";

const StoresFilterIcon = () => {
    const dispatch = useDispatch();
    const userStores = useSelector((state: RootState) => state.auth.user?.stores);
    const [selected, setSelected] = useState<number[]>([]);
    const [options, setOptions] = useState<IReactSelectOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        var storesIds = getStoresXUser()?.map((x) => x.storeId) || []
        setSelected(storesIds)
        var valuesAsFilterStore = storesIds.map((v) => {
            return { storeId: v };
        }) as IFilteredStore[];
        dispatch(setFilteredStoreList(valuesAsFilterStore));
        prepareDataForValidation()
    }, []);

    async function  prepareDataForValidation() {
        try {
            setLoading(true);
            const storeInfo = await getAllStores(dispatch);
            if(storeInfo.success)
                {
                    var filtered = storeInfo.data.filter(s => userStores?.includes(s.storeId));
                var options = filtered.map((s) => {
                    return { value: s.storeId, label: s.name }
                });
                setOptions(options);
            }

        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleSetFieldValue = (value: any) => {
        setSelected(value);

        var valuesAsFilterStore = value.map((v) => {
            return { storeId: v };
        }) as IFilteredStore[];

        dispatch(setFilteredStoreList(valuesAsFilterStore));
        setStoresXUser(value)
    };

    return (
        <div className="navbar-item form-group">
            <div className="btn-group shadow-none" hidden={false}>
                <button 
                    type="button" 
                    className="position-relative btn btn-sm shadow-none dropdown-toggle btn-no-bg-only" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                    data-toggle="tooltip" 
                    data-placement="bottom" 
                    title="Filtrar tiendas"
                >
                    <img 
                        width="40px" 
                        height={"auto"} 
                        src={store_filter} 
                        alt="badge icon for navbar" 
                        className="badge-nav-icon" 
                        style={{cursor:"pointer"}}
                    />
                    <span className="position-absolute translate-middle badge rounded-pill" style={{ right: '0%', top: "23%", backgroundColor: "#FF6F61", fontWeight: 600}}>
                        {selected?.length ?? 0}
                        <span className="visually-hidden">Tiendas seleccionadas</span>
                    </span>
                </button>

                <ul className="dropdown-menu" style={{minWidth: 200}}>
                {
                    options.length > 0 ? <>
                    <li key={"first"} className="pb-2 ps-2" >Seleccionar tienda(s):</li>
                    {
                        options.map((s: IReactSelectOption) => (
                        <li key={s.value} className="pb-2 ps-2"  style={{ display: 'flex', alignItems: 'top' }}>
                            <input 
                            className="form-check-input text-bg-light custom-checkbox" 
                            type="checkbox" 
                            id={s.value} 
                            style={{ flexShrink: 0, width: '15px', height: '15px' }} 
                            checked={selected.includes(s.value)}
                            onChange={() => {
                                let value = selected.includes(s.value) ? selected.filter(x => x !== s.value) : [...selected, s.value];
                                setSelected(value);
                                handleSetFieldValue(value);
                            }}
                            />
                            <label className="form-check-label" htmlFor={s.value}
                            style={{ marginLeft: '8px', whiteSpace: 'normal', }}
                            >{s.label}
                            </label>
                        </li>
                    )) }
                    </>
                    : <></>
                }
                </ul>
            </div>
        </div>
    );
}

export default StoresFilterIcon;